/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { spaceEventWithParams$ref } from "./spaceEventWithParams.graphql";
export type SearchSpaceParams = {|
  lang?: ?string,
  front?: ?boolean,
  boundaries?: ?$ReadOnlyArray<?$ReadOnlyArray<?number>>,
  category?: ?string,
  pattern?: ?$ReadOnlyArray<?string>,
  patternkeywords?: ?$ReadOnlyArray<?string>,
  dates?: ?SearchSpaceParamsDate,
  byHour?: ?boolean,
  riders?: ?$ReadOnlyArray<?number>,
  caracteristics?: ?$ReadOnlyArray<?string>,
  disposition?: ?$ReadOnlyArray<?string>,
  price?: ?SearchSpaceParamsRange,
  formuleprice?: ?SearchSpaceParamsRange,
  hof?: ?$ReadOnlyArray<?string>,
  utilities?: ?$ReadOnlyArray<?string>,
  equipments?: ?$ReadOnlyArray<?string>,
  subspaces?: ?$ReadOnlyArray<?string>,
  types?: ?$ReadOnlyArray<?string>,
  highceiling?: ?SearchSpaceParamsRange,
  floor?: ?$ReadOnlyArray<?string>,
  surface?: ?SearchSpaceParamsRange,
  vues?: ?$ReadOnlyArray<?string>,
  ambiences?: ?$ReadOnlyArray<?string>,
  extrasincluded?: ?$ReadOnlyArray<?string>,
  extrasservices?: ?$ReadOnlyArray<?string>,
  limit?: ?SearchSpaceParamsRange,
  locationOnly?: ?boolean,
  zoom?: ?number,
  circle?: ?Circle,
  hofRate?: ?string,
|};
export type SearchSpaceParamsDate = {|
  values?: ?$ReadOnlyArray<?SearchSpaceParamsDValues>,
  flexibility?: ?$ReadOnlyArray<?number>,
|};
export type SearchSpaceParamsDValues = {|
  date?: ?string,
  period?: ?number,
  hours?: ?number,
|};
export type SearchSpaceParamsRange = {|
  from?: ?number,
  to?: ?number,
|};
export type Circle = {|
  latlng?: ?$ReadOnlyArray<?number>,
  radius?: ?number,
|};
export type spaceEventWithParamsQueryVariables = {|
  params?: ?SearchSpaceParams,
  disposition?: ?$ReadOnlyArray<?string>,
  datesSelected?: ?$ReadOnlyArray<?any>,
  lang: string,
  riders?: ?number,
|};
export type spaceEventWithParamsQueryResponse = {|
  +$fragmentRefs: spaceEventWithParams$ref
|};
export type spaceEventWithParamsQuery = {|
  variables: spaceEventWithParamsQueryVariables,
  response: spaceEventWithParamsQueryResponse,
|};
*/


/*
query spaceEventWithParamsQuery(
  $params: SearchSpaceParams
  $disposition: [String]
  $datesSelected: [JSONObject]
  $lang: String!
  $riders: Int
) {
  ...spaceEventWithParams_134oxf
}

fragment spaceEventWithParams_134oxf on Query {
  results: searchSpaceByParams(params: $params) {
    resume
    spaces {
      id
      ...spaceResultSearchFragment_3po5Mt
    }
  }
}

fragment spaceResultSearchFragment_3po5Mt on Space {
  spaceId
  ref
  title(lang: $lang)
  surface
  rate
  type
  searchMap {
    location
    slug
    place_id
  }
  dataByCategory(category: "production") {
    hourlyRateExclTax
    price {
      amount
      amount_excl_tax
    }
    corpoPrice: price(input: {byViewer: true}) {
      amount
      amount_excl_tax
    }
    appliedDiscountPercent
    capacities {
      value: maxRidersByParams(category: "production", disposition: $disposition)
    }
    insta
  }
  pictures: searchElasPictures(count: 6) {
    nameId
    extension
    predictName
  }
  urlSpacefr: urlByLang(lang: "fr")
  urlSpaceen: urlByLang(lang: "en")
  urlSpacees: urlByLang(lang: "es")
  reviewCounter
  selection
  badge
  technicalSheet {
    isPublic
  }
  fidelityProgram
  isSuperhost: hasTags(tags: ["SUPERHOST"])
  covid_free
  searchSimuPrice(category: "production", dates: $datesSelected, riders: $riders)
  forceGeneratePicture
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datesSelected"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disposition"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "params"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "riders"
},
v5 = {
  "kind": "Variable",
  "name": "disposition",
  "variableName": "disposition"
},
v6 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v7 = {
  "kind": "Variable",
  "name": "params",
  "variableName": "params"
},
v8 = {
  "kind": "Variable",
  "name": "riders",
  "variableName": "riders"
},
v9 = {
  "kind": "Literal",
  "name": "category",
  "value": "production"
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount_excl_tax",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "spaceEventWithParamsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "datesSelected",
            "variableName": "datesSelected"
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "spaceEventWithParams"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "spaceEventWithParamsQuery",
    "selections": [
      {
        "alias": "results",
        "args": [
          (v7/*: any*/)
        ],
        "concreteType": "SearchSpacesForMap",
        "kind": "LinkedField",
        "name": "searchSpaceByParams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resume",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spaceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ref",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v6/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "surface",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchSpaceLocation",
                "kind": "LinkedField",
                "name": "searchMap",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "place_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v9/*: any*/)
                ],
                "concreteType": "DataByCategory",
                "kind": "LinkedField",
                "name": "dataByCategory",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hourlyRateExclTax",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "corpoPrice",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "input",
                        "value": {
                          "byViewer": true
                        }
                      }
                    ],
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": "price(input:{\"byViewer\":true})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appliedDiscountPercent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpaceCapacities",
                    "kind": "LinkedField",
                    "name": "capacities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "value",
                        "args": [
                          (v9/*: any*/),
                          (v5/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "maxRidersByParams",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "insta",
                    "storageKey": null
                  }
                ],
                "storageKey": "dataByCategory(category:\"production\")"
              },
              {
                "alias": "pictures",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "count",
                    "value": 6
                  }
                ],
                "concreteType": "SearchSpacePicture",
                "kind": "LinkedField",
                "name": "searchElasPictures",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nameId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "predictName",
                    "storageKey": null
                  }
                ],
                "storageKey": "searchElasPictures(count:6)"
              },
              {
                "alias": "urlSpacefr",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "fr"
                  }
                ],
                "kind": "ScalarField",
                "name": "urlByLang",
                "storageKey": "urlByLang(lang:\"fr\")"
              },
              {
                "alias": "urlSpaceen",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "en"
                  }
                ],
                "kind": "ScalarField",
                "name": "urlByLang",
                "storageKey": "urlByLang(lang:\"en\")"
              },
              {
                "alias": "urlSpacees",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lang",
                    "value": "es"
                  }
                ],
                "kind": "ScalarField",
                "name": "urlByLang",
                "storageKey": "urlByLang(lang:\"es\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reviewCounter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "selection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "badge",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SpaceTechnicalSheet",
                "kind": "LinkedField",
                "name": "technicalSheet",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublic",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fidelityProgram",
                "storageKey": null
              },
              {
                "alias": "isSuperhost",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "tags",
                    "value": [
                      "SUPERHOST"
                    ]
                  }
                ],
                "kind": "ScalarField",
                "name": "hasTags",
                "storageKey": "hasTags(tags:[\"SUPERHOST\"])"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "covid_free",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "dates",
                    "variableName": "datesSelected"
                  },
                  (v8/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "searchSimuPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forceGeneratePicture",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "42df83a66d14281c0624d9d37366684f",
    "id": null,
    "metadata": {},
    "name": "spaceEventWithParamsQuery",
    "operationKind": "query",
    "text": "query spaceEventWithParamsQuery(\n  $params: SearchSpaceParams\n  $disposition: [String]\n  $datesSelected: [JSONObject]\n  $lang: String!\n  $riders: Int\n) {\n  ...spaceEventWithParams_134oxf\n}\n\nfragment spaceEventWithParams_134oxf on Query {\n  results: searchSpaceByParams(params: $params) {\n    resume\n    spaces {\n      id\n      ...spaceResultSearchFragment_3po5Mt\n    }\n  }\n}\n\nfragment spaceResultSearchFragment_3po5Mt on Space {\n  spaceId\n  ref\n  title(lang: $lang)\n  surface\n  rate\n  type\n  searchMap {\n    location\n    slug\n    place_id\n  }\n  dataByCategory(category: \"production\") {\n    hourlyRateExclTax\n    price {\n      amount\n      amount_excl_tax\n    }\n    corpoPrice: price(input: {byViewer: true}) {\n      amount\n      amount_excl_tax\n    }\n    appliedDiscountPercent\n    capacities {\n      value: maxRidersByParams(category: \"production\", disposition: $disposition)\n    }\n    insta\n  }\n  pictures: searchElasPictures(count: 6) {\n    nameId\n    extension\n    predictName\n  }\n  urlSpacefr: urlByLang(lang: \"fr\")\n  urlSpaceen: urlByLang(lang: \"en\")\n  urlSpacees: urlByLang(lang: \"es\")\n  reviewCounter\n  selection\n  badge\n  technicalSheet {\n    isPublic\n  }\n  fidelityProgram\n  isSuperhost: hasTags(tags: [\"SUPERHOST\"])\n  covid_free\n  searchSimuPrice(category: \"production\", dates: $datesSelected, riders: $riders)\n  forceGeneratePicture\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '16fc5c4b29e7aacca7eff5b5af1934f9';

module.exports = node;
